import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

import * as PopoverPrimitive from '@radix-ui/react-popover'

import { classNames } from '@/utils/helpers.ts'

const Popover = PopoverPrimitive.Root

const PopoverTrigger = forwardRef<
  ElementRef<typeof PopoverPrimitive.Trigger>,
  ComponentPropsWithoutRef<typeof PopoverPrimitive.Trigger> & {
    testId?: string
  }
>(({ testId, ...props }, ref) => (
  <PopoverPrimitive.Trigger
    ref={ref}
    data-testid={testId}
    {...props}
  />
))

PopoverTrigger.displayName = 'PopoverTrigger'

const PopoverArrow = PopoverPrimitive.Arrow

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverClose = PopoverPrimitive.Close

const PopoverContent = forwardRef<
  ElementRef<typeof PopoverPrimitive.Content>,
  ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    testId?: string
  }
>(({ className, align = 'end', sideOffset = 8, testId, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={classNames(
        'z-[49] w-72 rounded-md border bg-card p-4 shadow-md ',
        className,
      )}
      data-testid={testId}
      {...props}
    />
  </PopoverPrimitive.Portal>
))

PopoverContent.displayName = 'PopoverContent'

export {
  Popover,
  PopoverAnchor,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverClose,
}
